import { useState } from 'react';

const useSelectedSamples = () => {
  // stores wells of selected samples
  const [selectedSamples, setSelectedSamples] = useState(new Set());

  const handleSelect = (sampleId) => {
    setSelectedSamples((selectedSamples) => {
      if (selectedSamples.has(sampleId)) {
        return new Set([...selectedSamples].filter((id) => id !== sampleId));
      } else {
        return new Set([...selectedSamples, sampleId]);
      }
    });
  };

  const getSelectedSamples = () => {
    return selectedSamples;
  };

  return {
    getSelectedSamples,
    handleSelect,
  };
};

export default useSelectedSamples;
